/** 无 hash 邀请落地页挂在 pathname 末尾（含旧路径），前面可能带 /client 这类部署前缀 */
const HISTORY_INVITE_PATHNAME_RE =
  /\/(?:project-group\/invite|project-group-invite|join\/[^/?#]+\/[^/?#]+)\/?$/;

/** 当前地址栏 pathname，去掉 index.html 以免把部署前缀算进文件名 */
function getLocationPathname() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  return String(window.location.pathname || "").replace(/\/index\.html$/i, "");
}

/**
 * hash 路由「#」前的部署前缀，例如 /client。
 * 根路径部署时返回空字符串，避免拼出双斜杠。
 */
export function resolveComicAiPublicPath() {
  let pathname = getLocationPathname();
  if (!pathname) return "";
  // 邀请落地页 pathname 带着分享路径，只留 # 前的服务器后缀
  pathname = pathname.replace(HISTORY_INVITE_PATHNAME_RE, "");
  const normalized = pathname.replace(/\/+$/, "");
  return !normalized || normalized === "/" ? "" : normalized;
}

/** 主应用当前 origin（供子应用回跳） */
export function resolveComicAiHostOrigin() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  return String(window.location.origin || "").replace(/\/$/, "");
}

/** origin + # 前部署前缀，例如 http://host/client */
export function resolveComicAiHostBase() {
  return `${resolveComicAiHostOrigin()}${resolveComicAiPublicPath()}`;
}

/** 主应用登录页（hash 路由） */
export function resolveComicAiLoginUrl() {
  return `${resolveComicAiHostBase()}/#/login`;
}

/** 主应用无线画布项目列表页 */
export function resolveComicAiWirelessCanvasUrl() {
  return `${resolveComicAiHostBase()}/#/visionCanvas`;
}
